import React, { FunctionComponent } from "react";
import { EventBlockTimeProperties, SetFieldValue } from "./schedule.types";
import DurationInput from "./formik-components/duration-input";
import { TimeSelectorWrapper } from "./formik-components/wrappers/time-selector-wrapper";
import { TimeDelegatorError } from "./time-type-delegator";

export const FixedTimeEditor: FunctionComponent<{
    values: EventBlockTimeProperties;
    setFieldValue: SetFieldValue<EventBlockTimeProperties>;
    includeEndTime: boolean;
    errors?: TimeDelegatorError;
}> = ({ values, setFieldValue, includeEndTime, errors }) => (
    <>
        <div className="time-selector-group top-time-type-row">
            <TimeSelectorWrapper
                timeName="startTime"
                className="input-container minutes-padding min-time-width"
                value={values.startTime}
                onChange={(val) => setFieldValue("startTime", val.target?.value)}
                error={errors?.startTime != null}
                helperText={errors?.startTime}
            />
            {includeEndTime && (
                <TimeSelectorWrapper
                    timeName="endTime"
                    className="input-container minutes-padding min-time-width"
                    value={values.endTime}
                    onChange={(val) => setFieldValue("endTime", val.target?.value)}
                    error={errors?.endTime != null}
                    helperText={errors?.endTime}
                />
            )}
        </div>
        {includeEndTime && (
            <div className="time-selector-group">
                <DurationInput value={values.duration} setFieldValue={setFieldValue} startTime={values.startTime} endTime={values.endTime} className="duration" />
            </div>
        )}
    </>
);
